import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { Auth0ProviderWithConfig } from './auth0-provider-with-config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithConfig>
        <App />
      </Auth0ProviderWithConfig>
    </BrowserRouter>
  </React.StrictMode>
);
